import { activeDirectory } from 'services/LocalStorage/localStorage';
import classes from 'components/App/AuthPublicPages/_common/LoginComponent/ActiveDirectory/activeDirectory.module.scss';
import { NewButton } from 'components/common/CustomizeButton/newButton';

const ActiveDirectory = () => {
    const handleSSOClick = () => {
        const url = new URL(document.URL);
        const isProduction = process.env.NODE_ENV === 'production';
        window.location.href =
            isProduction && window['ENV_VARIABLES']
                ? window['ENV_VARIABLES']['REACT_APP_ACTIVE_DIRECTORY_URL'].replace('$$_IP$$', url.hostname)
                : activeDirectory.get();
    };

    return (
        <div className={classes.ActiveDirectoryContainer}>
            <div className={classes.ssoButtonWrapper}>
                <NewButton
                    color="login"
                    variant="contained"
                    className={classes.submit}
                    id="sso-button"
                    data-testid={'sso-button'}
                    onClick={handleSSOClick}
                >
                    Continue with SSO
                </NewButton>
            </div>
        </div>
    );
};

export default ActiveDirectory;
